import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5fc16b64 = () => interopDefault(import('../pages/co-creation-terms-of-use.vue' /* webpackChunkName: "pages/co-creation-terms-of-use" */))
const _16354c70 = () => interopDefault(import('../pages/cookies-policy.vue' /* webpackChunkName: "pages/cookies-policy" */))
const _14730426 = () => interopDefault(import('../pages/cybersecurity-policy.vue' /* webpackChunkName: "pages/cybersecurity-policy" */))
const _4cdf3aec = () => interopDefault(import('../pages/data-privacy-policy.vue' /* webpackChunkName: "pages/data-privacy-policy" */))
const _ecd9a144 = () => interopDefault(import('../pages/glossary.vue' /* webpackChunkName: "pages/glossary" */))
const _d65c6f9a = () => interopDefault(import('../pages/hotmart-card-policies.vue' /* webpackChunkName: "pages/hotmart-card-policies" */))
const _29d3427c = () => interopDefault(import('../pages/payments-policy.vue' /* webpackChunkName: "pages/payments-policy" */))
const _4e597452 = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _654c630a = () => interopDefault(import('../pages/purchase-terms.vue' /* webpackChunkName: "pages/purchase-terms" */))
const _2bd4722f = () => interopDefault(import('../pages/responsible-use-policy.vue' /* webpackChunkName: "pages/responsible-use-policy" */))
const _75009c57 = () => interopDefault(import('../pages/terms-of-use.vue' /* webpackChunkName: "pages/terms-of-use" */))
const _938053ea = () => interopDefault(import('../pages/whatsapp-business.vue' /* webpackChunkName: "pages/whatsapp-business" */))
const _1d535c7c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/co-creation-terms-of-use",
    component: _5fc16b64,
    pathToRegexpOptions: {"strict":true},
    name: "co-creation-terms-of-use"
  }, {
    path: "/cookies-policy",
    component: _16354c70,
    pathToRegexpOptions: {"strict":true},
    name: "cookies-policy"
  }, {
    path: "/cybersecurity-policy",
    component: _14730426,
    pathToRegexpOptions: {"strict":true},
    name: "cybersecurity-policy"
  }, {
    path: "/data-privacy-policy",
    component: _4cdf3aec,
    pathToRegexpOptions: {"strict":true},
    name: "data-privacy-policy"
  }, {
    path: "/glossary",
    component: _ecd9a144,
    pathToRegexpOptions: {"strict":true},
    name: "glossary"
  }, {
    path: "/hotmart-card-policies",
    component: _d65c6f9a,
    pathToRegexpOptions: {"strict":true},
    name: "hotmart-card-policies"
  }, {
    path: "/payments-policy",
    component: _29d3427c,
    pathToRegexpOptions: {"strict":true},
    name: "payments-policy"
  }, {
    path: "/privacy-policy",
    component: _4e597452,
    pathToRegexpOptions: {"strict":true},
    name: "privacy-policy"
  }, {
    path: "/purchase-terms",
    component: _654c630a,
    pathToRegexpOptions: {"strict":true},
    name: "purchase-terms"
  }, {
    path: "/responsible-use-policy",
    component: _2bd4722f,
    pathToRegexpOptions: {"strict":true},
    name: "responsible-use-policy"
  }, {
    path: "/terms-of-use",
    component: _75009c57,
    pathToRegexpOptions: {"strict":true},
    name: "terms-of-use"
  }, {
    path: "/whatsapp-business",
    component: _938053ea,
    pathToRegexpOptions: {"strict":true},
    name: "whatsapp-business"
  }, {
    path: "/en/legal",
    component: _1d535c7c,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/es/legal",
    component: _1d535c7c,
    pathToRegexpOptions: {"strict":true},
    name: "index___es"
  }, {
    path: "/fr/legal",
    component: _1d535c7c,
    pathToRegexpOptions: {"strict":true},
    name: "index___fr"
  }, {
    path: "/it/legal",
    component: _1d535c7c,
    pathToRegexpOptions: {"strict":true},
    name: "index___it"
  }, {
    path: "/ja/legal",
    component: _1d535c7c,
    pathToRegexpOptions: {"strict":true},
    name: "index___ja"
  }, {
    path: "/pt-br/legal",
    component: _1d535c7c,
    pathToRegexpOptions: {"strict":true},
    name: "index___pt-br"
  }, {
    path: "/en/legal/co-creation-terms-of-use",
    component: _5fc16b64,
    pathToRegexpOptions: {"strict":true},
    name: "co-creation-terms-of-use___en"
  }, {
    path: "/en/legal/cookies-policy",
    component: _16354c70,
    pathToRegexpOptions: {"strict":true},
    name: "cookies-policy___en"
  }, {
    path: "/en/legal/cybersecurity-policy",
    component: _14730426,
    pathToRegexpOptions: {"strict":true},
    name: "cybersecurity-policy___en"
  }, {
    path: "/en/legal/data-privacy-policy",
    component: _4cdf3aec,
    pathToRegexpOptions: {"strict":true},
    name: "data-privacy-policy___en"
  }, {
    path: "/en/legal/glossary",
    component: _ecd9a144,
    pathToRegexpOptions: {"strict":true},
    name: "glossary___en"
  }, {
    path: "/en/legal/hotmart-card-policies",
    component: _d65c6f9a,
    pathToRegexpOptions: {"strict":true},
    name: "hotmart-card-policies___en"
  }, {
    path: "/en/legal/payments-policy",
    component: _29d3427c,
    pathToRegexpOptions: {"strict":true},
    name: "payments-policy___en"
  }, {
    path: "/en/legal/privacy-notice",
    component: _4e597452,
    pathToRegexpOptions: {"strict":true},
    name: "privacy-policy___en"
  }, {
    path: "/en/legal/purchase-terms",
    component: _654c630a,
    pathToRegexpOptions: {"strict":true},
    name: "purchase-terms___en"
  }, {
    path: "/en/legal/responsible-use-policy",
    component: _2bd4722f,
    pathToRegexpOptions: {"strict":true},
    name: "responsible-use-policy___en"
  }, {
    path: "/en/legal/terms-of-use",
    component: _75009c57,
    pathToRegexpOptions: {"strict":true},
    name: "terms-of-use___en"
  }, {
    path: "/en/legal/whatsapp-business",
    component: _938053ea,
    pathToRegexpOptions: {"strict":true},
    name: "whatsapp-business___en"
  }, {
    path: "/es/legal/aviso-de-privacidad",
    component: _4e597452,
    pathToRegexpOptions: {"strict":true},
    name: "privacy-policy___es"
  }, {
    path: "/es/legal/glosario",
    component: _ecd9a144,
    pathToRegexpOptions: {"strict":true},
    name: "glossary___es"
  }, {
    path: "/es/legal/plazo-de-compra",
    component: _654c630a,
    pathToRegexpOptions: {"strict":true},
    name: "purchase-terms___es"
  }, {
    path: "/es/legal/politica-de-cookies",
    component: _16354c70,
    pathToRegexpOptions: {"strict":true},
    name: "cookies-policy___es"
  }, {
    path: "/es/legal/politica-de-pago",
    component: _29d3427c,
    pathToRegexpOptions: {"strict":true},
    name: "payments-policy___es"
  }, {
    path: "/es/legal/politica-de-seguridad",
    component: _14730426,
    pathToRegexpOptions: {"strict":true},
    name: "cybersecurity-policy___es"
  }, {
    path: "/es/legal/politicas-de-tarjetas-hotmart",
    component: _d65c6f9a,
    pathToRegexpOptions: {"strict":true},
    name: "hotmart-card-policies___es"
  }, {
    path: "/es/legal/politicas-de-uso",
    component: _2bd4722f,
    pathToRegexpOptions: {"strict":true},
    name: "responsible-use-policy___es"
  }, {
    path: "/es/legal/privacidad-de-datos",
    component: _4cdf3aec,
    pathToRegexpOptions: {"strict":true},
    name: "data-privacy-policy___es"
  }, {
    path: "/es/legal/terminos-de-uso",
    component: _75009c57,
    pathToRegexpOptions: {"strict":true},
    name: "terms-of-use___es"
  }, {
    path: "/es/legal/terminos-de-uso-de-la-coproduccion",
    component: _5fc16b64,
    pathToRegexpOptions: {"strict":true},
    name: "co-creation-terms-of-use___es"
  }, {
    path: "/es/legal/whatsapp-business",
    component: _938053ea,
    pathToRegexpOptions: {"strict":true},
    name: "whatsapp-business___es"
  }, {
    path: "/fr/legal/conditions-dutilisation-de-la-coproduction",
    component: _5fc16b64,
    pathToRegexpOptions: {"strict":true},
    name: "co-creation-terms-of-use___fr"
  }, {
    path: "/fr/legal/conditions-generales-dachat",
    component: _654c630a,
    pathToRegexpOptions: {"strict":true},
    name: "purchase-terms___fr"
  }, {
    path: "/fr/legal/conditions-generales-dutilisation",
    component: _75009c57,
    pathToRegexpOptions: {"strict":true},
    name: "terms-of-use___fr"
  }, {
    path: "/fr/legal/glossaire",
    component: _ecd9a144,
    pathToRegexpOptions: {"strict":true},
    name: "glossary___fr"
  }, {
    path: "/fr/legal/politique-de-confidentialite",
    component: _4cdf3aec,
    pathToRegexpOptions: {"strict":true},
    name: "data-privacy-policy___fr"
  }, {
    path: "/fr/legal/politique-de-cookies",
    component: _16354c70,
    pathToRegexpOptions: {"strict":true},
    name: "cookies-policy___fr"
  }, {
    path: "/fr/legal/politique-de-paiements",
    component: _29d3427c,
    pathToRegexpOptions: {"strict":true},
    name: "payments-policy___fr"
  }, {
    path: "/fr/legal/politique-de-securite",
    component: _14730426,
    pathToRegexpOptions: {"strict":true},
    name: "cybersecurity-policy___fr"
  }, {
    path: "/fr/legal/politique-generale-dutilisation-responsable",
    component: _2bd4722f,
    pathToRegexpOptions: {"strict":true},
    name: "responsible-use-policy___fr"
  }, {
    path: "/it/legal/glossario",
    component: _ecd9a144,
    pathToRegexpOptions: {"strict":true},
    name: "glossary___it"
  }, {
    path: "/it/legal/politica-di-pagamento",
    component: _29d3427c,
    pathToRegexpOptions: {"strict":true},
    name: "payments-policy___it"
  }, {
    path: "/it/legal/politica-generale-di-utilizzo-responsabile",
    component: _2bd4722f,
    pathToRegexpOptions: {"strict":true},
    name: "responsible-use-policy___it"
  }, {
    path: "/it/legal/politica-sulla-privacy",
    component: _4cdf3aec,
    pathToRegexpOptions: {"strict":true},
    name: "data-privacy-policy___it"
  }, {
    path: "/it/legal/termini-di-utilizzo-della-coproduzione",
    component: _5fc16b64,
    pathToRegexpOptions: {"strict":true},
    name: "co-creation-terms-of-use___it"
  }, {
    path: "/it/legal/termini-generali-di-acquisto",
    component: _654c630a,
    pathToRegexpOptions: {"strict":true},
    name: "purchase-terms___it"
  }, {
    path: "/it/legal/termini-generali-di-utilizzo",
    component: _75009c57,
    pathToRegexpOptions: {"strict":true},
    name: "terms-of-use___it"
  }, {
    path: "/ja/legal/%E3%81%AE%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84%E3%81%AE%E7%94%A8%E8%AA%9E%E9%9B%86",
    component: _ecd9a144,
    pathToRegexpOptions: {"strict":true},
    name: "glossary___ja"
  }, {
    path: "/ja/legal/%E3%81%AE%E8%B2%AC%E4%BB%BB%E3%81%82%E3%82%8B%E4%BD%BF%E7%94%A8%E3%81%AE%E4%B8%80%E8%88%AC%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC",
    component: _2bd4722f,
    pathToRegexpOptions: {"strict":true},
    name: "responsible-use-policy___ja"
  }, {
    path: "/ja/legal/%E3%82%B3%E3%83%BB%E3%83%97%E3%83%AD%E3%83%80%E3%82%AF%E3%82%B7%E3%83%A7%E3%83%B3%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84",
    component: _5fc16b64,
    pathToRegexpOptions: {"strict":true},
    name: "co-creation-terms-of-use___ja"
  }, {
    path: "/ja/legal/%E3%83%97%E3%83%A9%E3%82%A4%E3%83%90%E3%82%B7%E3%83%BC%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC",
    component: _4cdf3aec,
    pathToRegexpOptions: {"strict":true},
    name: "data-privacy-policy___ja"
  }, {
    path: "/ja/legal/%E4%B8%80%E8%88%AC%E6%94%AF%E6%89%95%E8%A6%8F%E7%B4%84",
    component: _29d3427c,
    pathToRegexpOptions: {"strict":true},
    name: "payments-policy___ja"
  }, {
    path: "/ja/legal/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84",
    component: _75009c57,
    pathToRegexpOptions: {"strict":true},
    name: "terms-of-use___ja"
  }, {
    path: "/ja/legal/%E8%B3%BC%E5%85%A5%E8%A6%8F%E7%B4%84",
    component: _654c630a,
    pathToRegexpOptions: {"strict":true},
    name: "purchase-terms___ja"
  }, {
    path: "/pt-br/legal/aviso-de-privacidade",
    component: _4e597452,
    pathToRegexpOptions: {"strict":true},
    name: "privacy-policy___pt-br"
  }, {
    path: "/pt-br/legal/glossario",
    component: _ecd9a144,
    pathToRegexpOptions: {"strict":true},
    name: "glossary___pt-br"
  }, {
    path: "/pt-br/legal/politica-de-cookies",
    component: _16354c70,
    pathToRegexpOptions: {"strict":true},
    name: "cookies-policy___pt-br"
  }, {
    path: "/pt-br/legal/politica-de-seguranca-cibernetica",
    component: _14730426,
    pathToRegexpOptions: {"strict":true},
    name: "cybersecurity-policy___pt-br"
  }, {
    path: "/pt-br/legal/politicas-de-pagamento",
    component: _29d3427c,
    pathToRegexpOptions: {"strict":true},
    name: "payments-policy___pt-br"
  }, {
    path: "/pt-br/legal/politicas-de-uso",
    component: _2bd4722f,
    pathToRegexpOptions: {"strict":true},
    name: "responsible-use-policy___pt-br"
  }, {
    path: "/pt-br/legal/politicas-do-cartao-hotmart-para-o-brasil",
    component: _d65c6f9a,
    pathToRegexpOptions: {"strict":true},
    name: "hotmart-card-policies___pt-br"
  }, {
    path: "/pt-br/legal/privacidade-de-dados",
    component: _4cdf3aec,
    pathToRegexpOptions: {"strict":true},
    name: "data-privacy-policy___pt-br"
  }, {
    path: "/pt-br/legal/termos-de-compra",
    component: _654c630a,
    pathToRegexpOptions: {"strict":true},
    name: "purchase-terms___pt-br"
  }, {
    path: "/pt-br/legal/termos-de-uso",
    component: _75009c57,
    pathToRegexpOptions: {"strict":true},
    name: "terms-of-use___pt-br"
  }, {
    path: "/pt-br/legal/termos-de-uso-da-coproducao",
    component: _5fc16b64,
    pathToRegexpOptions: {"strict":true},
    name: "co-creation-terms-of-use___pt-br"
  }, {
    path: "/pt-br/legal/whatsapp-business",
    component: _938053ea,
    pathToRegexpOptions: {"strict":true},
    name: "whatsapp-business___pt-br"
  }, {
    path: "/",
    component: _1d535c7c,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
